<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom:50px;margin-top:18px;"
  >
    <el-form
      :model="role"
      ref="role"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.RoleName") }}
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="name"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <el-input v-model="role.name" :name="'name'" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.FunctionSelection") }}
                </label>
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <el-table
                    :data="functionList"
                    style="width: 100%"
                    border
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    row-key="id"
                    default-expand-all
                    :tree-props="{
                      children: 'children',
                      hasChildren: 'hasChildren'
                    }"
                    :cell-class-name="cell"
                  >
                    <el-table-column width="80" label="View">
                      <template slot-scope="scope">
                        <el-checkbox
                          @change="handleClick(scope.row)"
                          v-model="scope.row.selected"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="Function"
                      width="280"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      :label="item.name"
                      v-for="(item,index) in roleKeyList"
                      :key="index"
                    >
                      <template
                        slot-scope="scope"
                        v-if="!scope.row.children && scope.row[item.key]"
                      >
                        <el-checkbox
                          @change="handleClick(scope.row[item.key])"
                          v-model="scope.row[item.key].selected"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      v-if="
                        (checkPermission('ROLE_LIST_EDIT') &&
                          $route.query.id) ||
                          (checkPermission('ROLE_LIST_ADD') &&
                            !$route.query.id)
                      "
                      @click="checkEvent()"
                      >{{ $t("message.Save") }}</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import config from "../config";

const FUNCTION_TYPE_MENU = 1;
const FUNCTION_TYPE_BTN = 2;

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      role: {},
      roleList: [],
      functionList: [],
      node: [],
      roleKeyList: [
        {
          name: "Edit",
          key: "EDIT"
        },
        {
          name: "Create",
          key: "ADD"
        },
        {
          name: "Delete",
          key: "DEL"
        },
        {
          name:"Order",
          key:"ORDER"
        },
        {
          name:"Approval",
          key:"APPROVAL"
        }
      ]
    };
  },
  created() {
    this.init();
  },
  watch: {
    role: {
      handler: function() {
        this.$store.state.edit = true;
      },
      deep: true
    },
    functionList: {
      handler: function() {
        this.$store.state.edit = true;
      },
      deep: true
    },
  },
  mounted() {},
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.getSystemRoleDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        this.$set(this, "role", data.data.result.role);
        this.node = data.data.result.roleFunctionIds;
        this.getRoleList();
      } else {
        let initUser = {
          id: null,
          roleName: ""
        };
        this.node = [];
        this.$set(this, "role", initUser);
        this.getRoleList();
      }
    },
    cell({row, column, rowIndex, columnIndex}){
      if(columnIndex == 0){
        return "text-right"
      }
    },
    async getRoleList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.getSystemFuncAllList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      for (var i = 0; i < data.data.result.length; i++) {
        data.data.result[i].name = data.data.result[i].name
        data.data.result[i].selected = false;
        for (var j = 0; j < this.node.length; j++) {
          if (data.data.result[i].id == this.node[j]) {
            data.data.result[i].selected = true;
          }
        }
      }
      var rootObj = { id: 0 };
      var self = this;
      var assembleFunction = function(parentObj, list) {
        for (var i = 0; i < list.length; i++) {
          var childObj = list[i];
          if (parentObj.id == childObj.parentId) {
            if (childObj.type == FUNCTION_TYPE_MENU) {
              if (!parentObj.children) {
                parentObj.children = [];
              }
              parentObj.children.push(childObj);
              assembleFunction(childObj, list);
            } else if (childObj.type == FUNCTION_TYPE_BTN) {
              self.roleKeyList.forEach(item => {
                if (
                  childObj.actionType == item.key
                ) {
                  parentObj[item.key] = childObj;
                }
              });
            }
          }
        }
      };
      assembleFunction(rootObj, data.data.result);

      var that = this;
      setTimeout(function() {
        that.$store.state.edit = false;
      },500);
      this.$set(this, "functionList", rootObj.children);
      this.$set(this, "roleList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
                that.callDelete();
              }
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
              }
            }
          ]
        });
      }
    },
    checkEvent: function() {
      this.$refs["role"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        obj.role = {}
        for (var key in this.role) {
          obj.role[key] = this.role[key];
        }
        var ids = [];
        var self = this;
        var assembleFunction = function(list) {
          for (var i = 0; i < list.length; i++) {
            var childObj = list[i];
            if (childObj.selected) {
              ids.push(childObj.id);
            }
            if (!childObj.children) {
              self.roleKeyList.forEach(item => {
                if (childObj[item.key] && childObj[item.key].selected) {
                  ids.push(childObj[item.key].id);
                }
              });
            } else {
              assembleFunction(childObj.children);
            }
          }
        };
        assembleFunction(this.functionList);
        if(ids.length==0){
          this.$toastr.w("Please select at least one function to enable the CMS");
          return;
        }
        obj.roleFunctionIds = ids;
        var data;
        if (this.$route.query.id) {
          obj.apiUrl = this.apiConfig.updateSystemRole;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.createSystemRole;
          data = await this.$store.dispatch("apiEvent", obj);
        }
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    handleClick(row) {
      var self = this;
      var assembleFunction = function(list) {
        for (var i = 0; i < list.length; i++) {
          var childObj = list[i];
          childObj.selected = row.selected;
          if (!childObj.children) {
            self.roleKeyList.forEach(item => {
              if (childObj[item.key]) {
                childObj[item.key].selected = row.selected;
              }
            });
          } else {
            assembleFunction(childObj.children);
          }
        }
      };
      if (row.children) {
        assembleFunction(row.children);
      } else if(!row.selected){
        this.roleKeyList.forEach(item => {
          if (row[item.key]) {
            row[item.key].selected = row.selected;
          }
        });
      }
      if(row.parentId!=0){
        var self = this;
        var assembleFunctionP = function(id, list) {
          for (var i = 0; i < list.length; i++) {
            var parentObj = list[i];
            if (id == parentObj.id) {
              if(row.selected){
                parentObj.selected = true;
              }
              if(parentObj.parentId!=0){
                assembleFunctionP(parentObj.parentId,self.functionList)
              }
              if(!row.selected){
                var isChecked = false;
                if(parentObj.children&&parentObj.children.length>0){
                  for(var j=0;j<parentObj.children.length;j++){
                    if(parentObj.children[j].selected){
                      isChecked = true;
                    }
                  }
                } else {
                  self.roleKeyList.forEach(item => {
                    if(parentObj[item.key]&&parentObj[item.key].selected){
                      isChecked = true;
                    }
                  });
                }
                if(!isChecked){
                  parentObj.selected = false;
                  assembleFunctionP(parentObj.parentId,self.functionList)
                }
              }
            }
            if(parentObj.children){
              assembleFunctionP(id,parentObj.children)
            }
          }
        };
        assembleFunctionP(row.parentId,this.functionList)
      }
    },
    Delete() {
      this.showWarning(1);
    },
    handleSelectionChange() {},
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.roleIds = [this.$route.query.id];
        obj.apiUrl = this.apiConfig.deleteSystemRole;
        let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    itemClick() {}
  }
};
</script>
